export default __webpack_public_path__ + "img/bgimage.37c18709.png";